import { ImgHTMLAttributes } from 'react'
import { cn, createComponent } from '@lair-finance/util'
import { ValidatorIconMap, ValidatorId } from '@/domains/validator/config'

export type TokenSymbolProps = Omit<ImgHTMLAttributes<HTMLDivElement>, 'src'> & {
  src: string
  size?: number
  hasBorder?: boolean
}

export const TokenSymbol = createComponent<HTMLDivElement, TokenSymbolProps>(({ src, size, hasBorder = true, className, ...props }, ref) => {
  return (
    <div className={cn('relative inline-flex-center aspect-square', className)} ref={ref} {...props}>
      {!hasBorder ? (
        <img src={src} width={size || props.width} height={size || props.height} className={cn('rounded-full', className)} />
      ) : (
        <>
          <img src={src} width={size || props.width} height={size || props.height} className={'rounded-full'} />
          <div className={'absolute inset-0 size-full rounded-full border border-greyscale-500'} />
        </>
      )}
    </div>
  )
}, 'TokenSymbol')

export type ValidatorSymbolProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  validatorId: ValidatorId
  size?: number
}

export const ValidatorSymbol = createComponent<HTMLImageElement, ValidatorSymbolProps>(({ validatorId, size, className, ...props }, ref) => {
  return (
    <img
      src={validatorId ? ValidatorIconMap[validatorId] : ''}
      ref={ref}
      {...props}
      width={size || props.width}
      height={size || props.height}
      className={cn('rounded-full border border-greyscale-500', className)}
    />
  )
}, 'ValidatorSymbol')
